import React from 'react';
import Header from '../common/Header';
import KwendaMan from '../assets/img/kwenda-man.svg';
import { Link } from 'react-router-dom';

const ComingSoon = () => {
  return (
    <>
      <Header/>
      <div className='comingsoon-container'>
        <img src={KwendaMan} alt='Kwenda - Coming Soon'/>
        <h1 style={{position:'absolute'}}>قريبا</h1>
        <p className='comingsoon-link'>
          للبحث عن رحلتك القادمة<Link className='link'> اضغط هنا</Link> 
        </p>
      </div>
    </>
  );
};

export default ComingSoon;